import { v4 as uuidv4 } from 'uuid';

export function generateGUID(): string {
  return uuidv4();
}

// Hex shape only, deliberately not RFC-4122 version/variant bits: the platform mixes UUIDv7 (entity PKs),
// UUIDv5 (the int->uuid migration mapping) and UUIDv4 (client-generated file keys), and `testGuid(n)` fixtures
// leave the version nibble at 0.
const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isGuid(value: unknown): value is string {
  return typeof value === 'string' && GUID_PATTERN.test(value);
}

// Guid.Empty — the UUID-era equivalent of a `0` primary key. `isGuid` accepts it by design (see above), so
// callers that need "a real, saved entity" must reject it explicitly.
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
